import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/AppScreens/Dashboard/Dashboard"));

const Login = lazy(() => import("../pages/AuthScreens/Login/Login"));

const ForgotPassword = lazy(
  () => import("../pages/AuthScreens/ForgotPassword/ForgotPassword"),
);

const UserDetails = lazy(
  () => import("../pages/AppScreens/UserManagement/UserDetails/UserDetails"),
);

const UserManagement = lazy(() =>
  import("../pages/AppScreens/UserManagement/UserManagement").then((m) => ({
    default: m.UserManagement,
  })),
);

const SubscriptionManagement = lazy(
  () => import("../pages/AppScreens/SubscriptionManagement/SubscriptionManagement"),
);

const ProfileManagement = lazy(
  () => import("../pages/AppScreens/ProfileManagement/ProfileManagement"),
);

export {
  Login,
  ForgotPassword,
  UserManagement,
  UserDetails,
  Dashboard,
  SubscriptionManagement,
  ProfileManagement,
};
